<li class:done={task.isDone}>
  <div class="hoverable-area">
    <label class:disabled={disabled}>
      <input type=checkbox bind:checked={task.isDone} on:change {disabled}>
      {@html titleWithClickableLinks}
    </label>

    {#if !isEarlierDate || isYesterday}
      <span
        class:selected={task.isRepeatable}
        on:click={toggleRepeatable}
        title="Повторить задачу завтра"
      >&infin;</span>
    {/if}

    {#if !task.isDone}
      <span
        on:click={moveTask}
        title={isEarlierDate ? 'Продублировать на сегодня' : 'Перенести на следующий день'}
      >&rarr;</span>
    {/if}

    {#if canEdit}
      <span
        on:click={removeTask}
        title="Удалить задачу"
      >&times;</span>
    {/if}
  </div>
</li>

<script>
  import Autolinker from 'autolinker';

  export let task;
  export let moveTask;
  export let removeTask;
  export let toggleRepeatable;
  export let disabled;
  export let canEdit;
  export let isEarlierDate;
  export let isYesterday;

  $: titleWithClickableLinks = Autolinker.link(task.title);
</script>

<style>
  label {
    display: inline-block;
  }

  .disabled {
    cursor: not-allowed;
  }

  span {
    padding-left: 4px;
    display: none;
  }

  span.selected {
    display: inline-block;
  }

  .hoverable-area {
    display: block;
  }

  .hoverable-area:hover {
    background: rgb(254,255,188);
    background: linear-gradient(90deg,
      rgba(162, 190, 255, .3) 0%,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  .hoverable-area:hover span {
    display: inline-block;
  }

  li.done label {
    text-decoration: line-through;
    opacity: .5;
  }

  .hoverable-area > span {
    user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -o-user-select: none;
    font-weight: 900;
    cursor: pointer;
  }

  .hoverable-area > span:hover {
    text-decoration: none;
  }

  li {
    margin-bottom: 2px;
  }
</style>
